<template>
    <v-container max-width="100%" style="margin-top: 2%;">
        <template>
            <v-row justify="center">
                <v-dialog v-model="confirmDialog" persistent max-width="500">
                    <v-card>
                        <v-card-title class="headline">
                            <span style="color: #d60000">{{ $t('system.alert') }}</span>
                        </v-card-title>
                        <v-card-text>
                            <span style="color: #d60000">{{ this.mensagemdialog }}</span>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red accent-4" class="white--text" @click="confirmDialog = false">{{
                                $t('button.dismiss') }}</v-btn>
                            <v-btn v-if="showConfirmButton" color="red accent-4" class="white--text"
                                @click="deleteFromDatabase">{{ $t('button.confirm') }}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-row>
        </template>
        <merus-data-table :headers="headers" :items="turnos" :mostrar-inativos="mostrarInativos" :loading="loadingtable"
            :default-multi-sort="defaultSort" :loading-text="$t('turnosFuncionarios.loading')" @update:displayedItems="displayedItemsForExport = $event">
            <template v-slot:toolbar>
                <CadastroToolbar :title="$t('turnosFuncionarios.title')" :token="token" :items="displayedItemsForExport !== null ? displayedItemsForExport : turnosFiltrados" :csv-title="$t('turnosFuncionarios.title')"
                    :pdf-title="$t('turnosFuncionarios.title')" :pdf-headers="headers" :pdf-filename="$t('turnosFuncionarios.title')" hide-search
                    :endpoint-upload-csv="canEdit || canInsert ? '/api/v1.0/processacsvturnosfuncionarios/' : null" @saveBulk="saveBulk"
                    :help-dialog-csv-fields="helpCSV" :help-dialog-csv-model="$t('turnosFuncionarios.title')" :csv-headers="headersCSV">
                    <template v-slot:extension>
                        <v-switch
                            v-model="mostrarInativos"
                            :label="$t('crudVeiculos.showInactive')"
                            class="ml-3 mr-4"
                            hide-details
                        ></v-switch>
                    </template>
                    <template v-slot:add v-if="canInsert">
                        <v-dialog v-model="dialog" max-width="80%">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn color="primary" dark small class="mb-2" v-bind="attrs" v-on="on" fab>
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>
                            </template>
                            <v-card>
                                <v-toolbar dark color="primary" ref="myToolbar">
                                    <v-btn icon dark @click="close">
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                    <v-toolbar-title>{{ $tc('turnosFuncionarios.self', 1) }}</v-toolbar-title>
                                </v-toolbar>

                                <v-card-text>
                                    <v-container>
                                        <v-form ref="form" v-model="formValidado">
                                            <v-row>
                                                <v-col cols="12" sm="6" md="3">
                                                    <v-text-field v-model="editedItem.cod_turno_funcionario" :label="$t('turnosFuncionarios.headers.code')"
                                                        :rules="[(v) => !!v || $t('rules.messageCode')]"></v-text-field>
                                                </v-col>

                                                <v-col cols="12" sm="6" md="5">
                                                    <v-text-field v-model="editedItem.descricao_turno_funcionario"
                                                        :label="$t('turnosFuncionarios.headers.description')"
                                                        :rules="[(v) => !!v || $t('rules.messageDescription')]"></v-text-field>
                                                </v-col>

                                                <v-col cols="12" sm="6" md="2">
                                                    <v-select v-model="editedItem.id_unidade" :items="unidades" item-text="cod_unidade"
                                                        item-value="id_unidade" :clearable="true" :label="$t('turnosPassageiros.headers.unit')"></v-select>
                                                </v-col>

                                                <v-col cols="12" sm="6" md="2">
                                                    <v-switch v-model="editedItem.ativo" :label="$t('turnosPassageiros.headers.active')"></v-switch>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" sm="2" md="2">
                                                    <span style="font-weight: bold;">{{ $t('turnosPassageiros.headers.validMonday') }}</span>
                                                </v-col>
                                                <v-col cols="12" sm="3" md="3">
                                                    <v-text-field 
                                                    v-model="editedItem.horario_inicio_segunda" :label="$t('turnosPassageiros.arrivalTime')"
                                                    prepend-icon="mdi-clock" v-mask="'##:##'" solo></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="3" md="3">
                                                    <v-text-field 
                                                    v-model="editedItem.horario_fim_segunda" :label="$t('turnosPassageiros.departureTime')"
                                                    prepend-icon="mdi-clock" v-mask="'##:##'" solo></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" sm="2" md="2">
                                                    <span style="font-weight: bold;">{{ $t('turnosPassageiros.headers.validTuesday') }}</span>
                                                </v-col>
                                                <v-col cols="12" sm="3" md="3">
                                                    <v-text-field 
                                                    v-model="editedItem.horario_inicio_terca" :label="$t('turnosPassageiros.arrivalTime')"
                                                    prepend-icon="mdi-clock" v-mask="'##:##'" solo></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="3" md="3">
                                                    <v-text-field 
                                                    v-model="editedItem.horario_fim_terca" :label="$t('turnosPassageiros.departureTime')"
                                                    prepend-icon="mdi-clock" v-mask="'##:##'" solo></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" sm="2" md="2">
                                                    <span style="font-weight: bold;">{{ $t('turnosPassageiros.headers.validWednesday') }}</span>
                                                </v-col>
                                                <v-col cols="12" sm="3" md="3">
                                                    <v-text-field 
                                                    v-model="editedItem.horario_inicio_quarta" :label="$t('turnosPassageiros.arrivalTime')"
                                                    prepend-icon="mdi-clock" v-mask="'##:##'" solo></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="3" md="3">
                                                    <v-text-field 
                                                    v-model="editedItem.horario_fim_quarta" :label="$t('turnosPassageiros.departureTime')"
                                                    prepend-icon="mdi-clock" v-mask="'##:##'" solo></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" sm="2" md="2">
                                                    <span style="font-weight: bold;">{{ $t('turnosPassageiros.headers.validThursday') }}</span>
                                                </v-col>
                                                <v-col cols="12" sm="3" md="3">
                                                    <v-text-field 
                                                    v-model="editedItem.horario_inicio_quinta" :label="$t('turnosPassageiros.arrivalTime')"
                                                    prepend-icon="mdi-clock" v-mask="'##:##'" solo></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="3" md="3">
                                                    <v-text-field 
                                                    v-model="editedItem.horario_fim_quinta" :label="$t('turnosPassageiros.departureTime')"
                                                    prepend-icon="mdi-clock" v-mask="'##:##'" solo></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" sm="2" md="2">
                                                    <span style="font-weight: bold;">{{ $t('turnosPassageiros.headers.validFriday') }}</span>
                                                </v-col>
                                                <v-col cols="12" sm="3" md="3">
                                                    <v-text-field 
                                                    v-model="editedItem.horario_inicio_sexta" :label="$t('turnosPassageiros.arrivalTime')"
                                                    prepend-icon="mdi-clock" v-mask="'##:##'" solo></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="3" md="3">
                                                    <v-text-field 
                                                    v-model="editedItem.horario_fim_sexta" :label="$t('turnosPassageiros.departureTime')"
                                                    prepend-icon="mdi-clock" v-mask="'##:##'" solo></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" sm="2" md="2">
                                                    <span style="font-weight: bold;">{{ $t('turnosPassageiros.headers.validSaturday') }}</span>
                                                </v-col>
                                                <v-col cols="12" sm="3" md="3">
                                                    <v-text-field 
                                                    v-model="editedItem.horario_inicio_sabado" :label="$t('turnosPassageiros.arrivalTime')"
                                                    prepend-icon="mdi-clock" v-mask="'##:##'" solo></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="3" md="3">
                                                    <v-text-field 
                                                    v-model="editedItem.horario_fim_sabado" :label="$t('turnosPassageiros.departureTime')"
                                                    prepend-icon="mdi-clock" v-mask="'##:##'" solo></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" sm="2" md="2">
                                                    <span style="font-weight: bold;">{{ $t('turnosPassageiros.headers.validSunday') }}</span>
                                                </v-col>
                                                <v-col cols="12" sm="3" md="3">
                                                    <v-text-field 
                                                    v-model="editedItem.horario_inicio_domingo" :label="$t('turnosPassageiros.arrivalTime')"
                                                    prepend-icon="mdi-clock" v-mask="'##:##'" solo></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="3" md="3">
                                                    <v-text-field 
                                                    v-model="editedItem.horario_fim_domingo" :label="$t('turnosPassageiros.departureTime')"
                                                    prepend-icon="mdi-clock" v-mask="'##:##'" solo></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-form>
                                    </v-container>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn dark color="primary" @click="close">{{ $t('button.cancel') }}</v-btn>
                                    <v-btn dark color="primary" @click="save">{{ $t('button.save') }}</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </template>
                </CadastroToolbar>

            </template>

            <template v-slot:item.valido_segunda="{ item }">
                <v-icon v-if="item.ativo == 0" color="grey">mdi-minus</v-icon>
                <v-icon v-if="item.ativo == 1 && item.valido_segunda == 1" color="green">mdi-check</v-icon>
                <v-icon v-if="item.ativo == 1 && item.valido_segunda == 0" color="red">mdi-close</v-icon>
            </template>
            <template v-slot:item.valido_terca="{ item }">
                <v-icon v-if="item.ativo == 0" color="grey">mdi-minus</v-icon>
                <v-icon v-if="item.ativo == 1 && item.valido_terca == 1" color="green">mdi-check</v-icon>
                <v-icon v-if="item.ativo == 1 && item.valido_terca == 0" color="red">mdi-close</v-icon>
            </template>
            <template v-slot:item.valido_quarta="{ item }">
                <v-icon v-if="item.ativo == 0" color="grey">mdi-minus</v-icon>
                <v-icon v-if="item.ativo == 1 && item.valido_quarta == 1" color="green">mdi-check</v-icon>
                <v-icon v-if="item.ativo == 1 && item.valido_quarta == 0" color="red">mdi-close</v-icon>
            </template>
            <template v-slot:item.valido_quinta="{ item }">
                <v-icon v-if="item.ativo == 0" color="grey">mdi-minus</v-icon>
                <v-icon v-if="item.ativo == 1 && item.valido_quinta == 1" color="green">mdi-check</v-icon>
                <v-icon v-if="item.ativo == 1 && item.valido_quinta == 0" color="red">mdi-close</v-icon>
            </template>
            <template v-slot:item.valido_sexta="{ item }">
                <v-icon v-if="item.ativo == 0" color="grey">mdi-minus</v-icon>
                <v-icon v-if="item.ativo == 1 && item.valido_sexta == 1" color="green">mdi-check</v-icon>
                <v-icon v-if="item.ativo == 1 && item.valido_sexta == 0" color="red">mdi-close</v-icon>
            </template>
            <template v-slot:item.valido_sabado="{ item }">
                <v-icon v-if="item.ativo == 0" color="grey">mdi-minus</v-icon>
                <v-icon v-if="item.ativo == 1 && item.valido_sabado == 1" color="green">mdi-check</v-icon>
                <v-icon v-if="item.ativo == 1 && item.valido_sabado == 0" color="red">mdi-close</v-icon>
            </template>
            <template v-slot:item.valido_domingo="{ item }">
                <v-icon v-if="item.ativo == 0" color="grey">mdi-minus</v-icon>
                <v-icon v-if="item.ativo == 1 && item.valido_domingo == 1" color="green">mdi-check</v-icon>
                <v-icon v-if="item.ativo == 1 && item.valido_domingo == 0" color="red">mdi-close</v-icon>
            </template>
            <template v-slot:item.ativo="{ item }">
                <span>{{ item.ativo == 1 ? $t('selectOptions.yes') : $t('selectOptions.no') }}</span>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon small class="mr-2" color="green" @click="editItem(item)" :disabled="!canEdit">mdi-pencil</v-icon>
                <v-icon small class="mr-2" color="red" @click="deleteItem(item)" :disabled="!canDelete">mdi-delete</v-icon>
            </template>
        </merus-data-table>
    </v-container>
</template>

<script>
    import apiController from "@/utils/apiController";
    import MerusDataTable from "./Tables/MerusDataTable.vue";
    import CadastroToolbar from "./Toolbars/CadastroToolbar.vue";
    import EventBus from "../utils/eventBus";

export default {
    components: {
        MerusDataTable,
        CadastroToolbar
    },
    data: () => ({
        turnos: [],
        mostrarInativos: false,
        unidades: [],
        loadingtable: true,
        confirmDialog: false,
        mensagemdialog: "",
        showConfirmButton: true,
        formValidado: true,
        dialog: false,
        editedIndex: -1,
        displayedItemsForExport: null,
        editedItem: {
            id_turno_funcionario: null,
            cod_turno_funcionario: null,
            descricao_turno_funcionario: null,
            horario_inicio_segunda: null,
            horario_fim_segunda: null,
            horario_inicio_terca: null,
            horario_fim_terca: null,
            horario_inicio_quarta: null,
            horario_fim_quarta: null,
            horario_inicio_quinta: null,
            horario_fim_quinta: null,
            horario_inicio_sexta: null,
            horario_fim_sexta: null,
            horario_inicio_sabado: null,
            horario_fim_sabado: null,
            horario_inicio_domingo: null,
            horario_fim_domingo: null,
            ativo: 1,
            id_unidade: null,
        },
        deletedItem: {
            id_turno_funcionario: null,
            cod_turno_funcionario: null,
            descricao_turno_funcionario: null,
            horario_inicio_segunda: null,
            horario_fim_segunda: null,
            horario_inicio_terca: null,
            horario_fim_terca: null,
            horario_inicio_quarta: null,
            horario_fim_quarta: null,
            horario_inicio_quinta: null,
            horario_fim_quinta: null,
            horario_inicio_sexta: null,
            horario_fim_sexta: null,
            horario_inicio_sabado: null,
            horario_fim_sabado: null,
            horario_inicio_domingo: null,
            horario_fim_domingo: null,
            ativo: 1,
            id_unidade: null,
        },
        defaultItem: {
            id_turno_funcionario: null,
            cod_turno_funcionario: null,
            descricao_turno_funcionario: null,
            horario_inicio_segunda: null,
            horario_fim_segunda: null,
            horario_inicio_terca: null,
            horario_fim_terca: null,
            horario_inicio_quarta: null,
            horario_fim_quarta: null,
            horario_inicio_quinta: null,
            horario_fim_quinta: null,
            horario_inicio_sexta: null,
            horario_fim_sexta: null,
            horario_inicio_sabado: null,
            horario_fim_sabado: null,
            horario_inicio_domingo: null,
            horario_fim_domingo: null,
            ativo: 1,
            id_unidade: null,
        },
        recursos: [],
        canInsert: false,
        canEdit: false,
        canDelete: false,
    }),
    computed: {
        turnosFiltrados() {
            if (!this.mostrarInativos) {
                return this.turnos.filter((t) => t.ativo === true || t.ativo === 1);
            }
            return this.turnos;
        },
        headers() {
            return [
                { text: this.$t('turnosFuncionarios.headers.idTurno'), value: "id_turno_funcionario", align: " d-none" },
                { text: this.$t('turnosPassageiros.headers.unit'), value: "cod_unidade", sortable: true, filtrable: true },
                { text: this.$t('turnosFuncionarios.headers.code'), value: "cod_turno_funcionario", sortable: true, filtrable: true },
                { text: this.$t('turnosFuncionarios.headers.description'), value: "descricao_turno_funcionario", sortable: true, filtrable: true },
                { text: this.$t('turnosPassageiros.headers.validMonday'), value: "valido_segunda", sortable: true, filtrable: true },
                { text: this.$t('turnosPassageiros.headers.validTuesday'), value: "valido_terca", sortable: true, filtrable: true },
                { text: this.$t('turnosPassageiros.headers.validWednesday'), value: "valido_quarta", sortable: true, filtrable: true },
                { text: this.$t('turnosPassageiros.headers.validThursday'), value: "valido_quinta", sortable: true, filtrable: true },
                { text: this.$t('turnosPassageiros.headers.validFriday'), value: "valido_sexta", sortable: true, filtrable: true },
                { text: this.$t('turnosPassageiros.headers.validSaturday'), value: "valido_sabado", sortable: true, filtrable: true },
                { text: this.$t('turnosPassageiros.headers.validSunday'), value: "valido_domingo", sortable: true, filtrable: true },
                { text: this.$t('turnosPassageiros.headers.active'), value: "ativo", sortable: true, filtrable: true },
                { text: this.$t('turnosFuncionarios.headers.actions'), value: "actions", sortable: false },
            ]
        },
        defaultSort() {
            return [
                { value: 'cod_turno_funcionario', options: { text: this.$t('turnosFuncionarios.increasing'), value: 1 } },
            ]
        },
        headersCSV() {
            return [
                { text: this.$t('csv.lineNumber'), value: 'line_number', error: 'error_line' },
                { text: this.$t('turnosFuncionarios.csv.operacao'), value: 'operacao' },
                { text: this.$t('turnosFuncionarios.headers.code'), value: 'cod_turno_funcionario' },
                { text: this.$t('turnosFuncionarios.headers.description'), value: 'descricao_turno_funcionario' },
                { text: this.$t('turnosPassageiros.headers.unit'), value: 'cod_unidade' },
                { text: this.$t('turnosPassageiros.headers.active'), value: 'ativo' },
                { text: this.$t('turnosFuncionarios.csv.horarioInicioSegunda'), value: 'horario_inicio_segunda' },
                { text: this.$t('turnosFuncionarios.csv.horarioFimSegunda'), value: 'horario_fim_segunda' },
                { text: this.$t('turnosFuncionarios.csv.horarioInicioTerca'), value: 'horario_inicio_terca' },
                { text: this.$t('turnosFuncionarios.csv.horarioFimTerca'), value: 'horario_fim_terca' },
                { text: this.$t('turnosFuncionarios.csv.horarioInicioQuarta'), value: 'horario_inicio_quarta' },
                { text: this.$t('turnosFuncionarios.csv.horarioFimQuarta'), value: 'horario_fim_quarta' },
                { text: this.$t('turnosFuncionarios.csv.horarioInicioQuinta'), value: 'horario_inicio_quinta' },
                { text: this.$t('turnosFuncionarios.csv.horarioFimQuinta'), value: 'horario_fim_quinta' },
                { text: this.$t('turnosFuncionarios.csv.horarioInicioSexta'), value: 'horario_inicio_sexta' },
                { text: this.$t('turnosFuncionarios.csv.horarioFimSexta'), value: 'horario_fim_sexta' },
                { text: this.$t('turnosFuncionarios.csv.horarioInicioSabado'), value: 'horario_inicio_sabado' },
                { text: this.$t('turnosFuncionarios.csv.horarioFimSabado'), value: 'horario_fim_sabado' },
                { text: this.$t('turnosFuncionarios.csv.horarioInicioDomingo'), value: 'horario_inicio_domingo' },
                { text: this.$t('turnosFuncionarios.csv.horarioFimDomingo'), value: 'horario_fim_domingo' },
            ];
        },
        helpCSV() {
            return [
                { label: this.$t('turnosFuncionarios.headers.code'), description: this.$t('turnosFuncionarios.csv.helpCode'), example: 'TF1', key: 'cod_turno_funcionario' },
                { label: this.$t('turnosFuncionarios.headers.description'), description: this.$t('turnosFuncionarios.csv.helpDescricao'), example: 'Turno manhã', key: 'descricao_turno_funcionario' },
                { label: this.$t('turnosPassageiros.headers.unit'), description: this.$t('turnosPassageiros.csv.helpCodUnidade'), example: 'UN001', key: 'cod_unidade' },
                { label: this.$t('turnosPassageiros.headers.active'), description: this.$t('turnosFuncionarios.csv.helpAtivo'), example: '1', key: 'ativo' },
                { label: this.$t('turnosFuncionarios.csv.horarioInicioSegunda'), description: this.$t('turnosFuncionarios.csv.helpHorariosDesc'), example: '08:00', key: 'horario_inicio_segunda' },
                { label: this.$t('turnosFuncionarios.csv.horarioFimSegunda'), description: this.$t('turnosFuncionarios.csv.helpHorariosDesc'), example: '17:00', key: 'horario_fim_segunda' },
                { label: this.$t('turnosFuncionarios.csv.horarioInicioTerca'), description: this.$t('turnosFuncionarios.csv.helpHorariosDesc'), example: '08:00', key: 'horario_inicio_terca' },
                { label: this.$t('turnosFuncionarios.csv.horarioFimTerca'), description: this.$t('turnosFuncionarios.csv.helpHorariosDesc'), example: '17:00', key: 'horario_fim_terca' },
                { label: this.$t('turnosFuncionarios.csv.horarioInicioQuarta'), description: this.$t('turnosFuncionarios.csv.helpHorariosDesc'), example: '08:00', key: 'horario_inicio_quarta' },
                { label: this.$t('turnosFuncionarios.csv.horarioFimQuarta'), description: this.$t('turnosFuncionarios.csv.helpHorariosDesc'), example: '17:00', key: 'horario_fim_quarta' },
                { label: this.$t('turnosFuncionarios.csv.horarioInicioQuinta'), description: this.$t('turnosFuncionarios.csv.helpHorariosDesc'), example: '08:00', key: 'horario_inicio_quinta' },
                { label: this.$t('turnosFuncionarios.csv.horarioFimQuinta'), description: this.$t('turnosFuncionarios.csv.helpHorariosDesc'), example: '17:00', key: 'horario_fim_quinta' },
                { label: this.$t('turnosFuncionarios.csv.horarioInicioSexta'), description: this.$t('turnosFuncionarios.csv.helpHorariosDesc'), example: '08:00', key: 'horario_inicio_sexta' },
                { label: this.$t('turnosFuncionarios.csv.horarioFimSexta'), description: this.$t('turnosFuncionarios.csv.helpHorariosDesc'), example: '17:00', key: 'horario_fim_sexta' },
                { label: this.$t('turnosFuncionarios.csv.horarioInicioSabado'), description: this.$t('turnosFuncionarios.csv.helpHorariosDesc'), example: '08:00', key: 'horario_inicio_sabado' },
                { label: this.$t('turnosFuncionarios.csv.horarioFimSabado'), description: this.$t('turnosFuncionarios.csv.helpHorariosDesc'), example: '17:00', key: 'horario_fim_sabado' },
                { label: this.$t('turnosFuncionarios.csv.horarioInicioDomingo'), description: this.$t('turnosFuncionarios.csv.helpHorariosDesc'), example: '08:00', key: 'horario_inicio_domingo' },
                { label: this.$t('turnosFuncionarios.csv.horarioFimDomingo'), description: this.$t('turnosFuncionarios.csv.helpHorariosDesc'), example: '17:00', key: 'horario_fim_domingo' },
            ];
        },

    },
    watch: {
        '$i18n.locale'() {
            this.initialize();
            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }
        }
    },
    created() {
        this.user = JSON.parse(sessionStorage.getItem("user"));
        this.token = sessionStorage.getItem("api");
        this.populaUnidades();
        this.populaRecursos();
    },
    methods: {
        populaUnidades() {
            apiController.request(apiController.endpoints.getallUnidadesativas, {
                onSuccess: (response) => {
                    this.unidades = response.data;
                },
            });
        },
        populaRecursos() {
            if (this.user.is_superadmin === 1) {
                apiController.request(apiController.endpoints.getallRecursos, {
                    onSuccess: (response) => {
                        this.recursos = response.data;
                        this.canEdit = true;
                        this.canInsert = true;
                        this.canDelete = true;
                        this.initialize();
                    },
                });
            } else {
                apiController.request(apiController.endpoints.getRecursosusuario, {
                    params: { id: this.user.id_usuario },
                    onSuccess: (response) => {
                        this.recursos = response.data;
                        this.canEdit = this.recursos.some((r) => r.rota === "/api/v1.0/updateturnofuncionario");
                        this.canInsert = this.recursos.some((r) => r.rota === "/api/v1.0/insertturnofuncionario");
                        this.canDelete = this.recursos.some((r) => r.rota === "/api/v1.0/deleteturnofuncionario");
                        this.initialize();
                    },
                });
            }
        },
        initialize() {
            apiController.request(apiController.endpoints.getallTurnosfuncionarios, {
                onSuccess: (response) => {
                    this.turnos = response.data;
                    this.loadingtable = false;
                },
            });
        },
        close() {
            this.dialog = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.deletedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },
        editItem(item) {
            this.editedIndex = this.turnos.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.operacao = 1;
            this.dialog = true;
        },
        deleteItem(item) {
            this.deletedItem = Object.assign({}, item);
            this.operacao = 2;
            this.mensagemdialog = this.$t('turnosFuncionarios.deleteTurno') + ` ${this.deletedItem.descricao_turno_funcionario}?`
            this.showConfirmButton = true;
            this.confirmDialog = true;
        },
        deleteFromDatabase() {
            apiController.request(apiController.endpoints.deleteTurnofuncionario, {
                    data: this.deletedItem,
                    onSuccess: (response) => {
                        this.updateTable(response.data.erro);
                        this.confirmDialog = false;
                    },
                    onError: () => {
                        this.confirmDialog = false;
                    },
                });
            },
            save(){
                this.$refs.form.validate();
                if (this.formValidado) {
                    const horarioFields = [
                        'horario_inicio_segunda', 'horario_fim_segunda',
                        'horario_inicio_terca', 'horario_fim_terca',
                        'horario_inicio_quarta', 'horario_fim_quarta',
                        'horario_inicio_quinta', 'horario_fim_quinta',
                        'horario_inicio_sexta', 'horario_fim_sexta',
                        'horario_inicio_sabado', 'horario_fim_sabado',
                        'horario_inicio_domingo', 'horario_fim_domingo',
                    ];
                    horarioFields.forEach((field) => {
                        if (this.editedItem[field] === '') {
                            this.editedItem[field] = null;
                        }
                    });

                    if (this.editedIndex == -1) {
                        this.operacao = 0;

                    apiController.request(apiController.endpoints.insertTurnofuncionario, {
                        data: this.editedItem,
                        onSuccess: (response) => {
                            this.updateTable(response.data.erro);
                        },
                    });
                } else {
                    this.operacao = 1;
                    apiController.request(apiController.endpoints.updateTurnofuncionario, {
                        data: this.editedItem,
                        onSuccess: (response) => {
                            this.updateTable(response.data.erro);
                        },
                    });
                }
            }
        },
        updateTable(status) {
                let mensagem = "";
                let tipo = status ? "error" : "success";
                
            if (status) {
                if (this.operacao == 0) {
                    mensagem = this.$t('turnosFuncionarios.alerts.error.insert');
                } else {
                    if (this.operacao == 1) {
                        mensagem = this.$t('turnosFuncionarios.alerts.error.update');
                    } else {
                        mensagem = this.$t('turnosFuncionarios.alerts.error.delete');
                    }
                    }
                } else {
                    if (this.operacao == 0) {
                    mensagem = this.$t('turnosFuncionarios.alerts.success.insert');
                    } else {
                    if (this.operacao == 1) {
                        mensagem = this.$t('turnosFuncionarios.alerts.success.update');
                    } else {
                        mensagem = this.$t('turnosFuncionarios.alerts.success.delete');
                    }
                    }
                }
                
                EventBus.$emit('show-alert', { mensagem, tipo });
                this.close();
                this.initialize();
            },
        saveBulk(result) {
            apiController.request(apiController.endpoints.upsertTurnosfuncionariosbulk, {
                data: result,
                onSuccess: (response) => {
                    this.updateTable(response.data.erro);
                },
            });
        },
        },
    }
</script>
